"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _MenuItemContent = _interopRequireDefault(require("./MenuItemContent"));

var _Link = _interopRequireDefault(require("../link/Link"));

var _MenuContext = _interopRequireDefault(require("./MenuContext"));

function MenuLeaf(_ref) {
  var item = _ref.item,
      trackSelected = _ref.trackSelected,
      others = (0, _objectWithoutProperties2["default"])(_ref, ["item", "trackSelected"]);

  var _useContext = (0, _react.useContext)(_MenuContext["default"]),
      close = _useContext.close,
      classes = _useContext.classes;

  return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    href: item.href,
    as: item.as,
    className: classes.link,
    server: item.server,
    pageData: item.pageData ? item.pageData : null,
    onClick: close
  }, /*#__PURE__*/_react["default"].createElement("a", null, /*#__PURE__*/_react["default"].createElement(_MenuItemContent["default"], (0, _extends2["default"])({}, others, {
    item: item,
    showExpander: false,
    leaf: true
  }))));
}

var _default = /*#__PURE__*/_react["default"].memo(MenuLeaf);

exports["default"] = _default;
